// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BZ-u","newExpiryDate":"styles_newExpiryDate__1PJeM","footer":"styles_footer__R73uk"};